import React from 'react';
import { Link, Typography } from '@mui/material';
import { Alert } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { useActiveOutOfOfficeQuery, useProviderPublicMatchingProfile } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';


export type OutOfOfficeNoticeProps = {
  providerId: string;
};


export const OutOfOfficeNotice: React.VFC<OutOfOfficeNoticeProps> = ({ providerId }) => {
  const l10n = useL10n();
  const { data: outOfOffice, isLoading } = useActiveOutOfOfficeQuery(providerId);
  const { data: provider } = useProviderPublicMatchingProfile(providerId);

  if (isLoading || !outOfOffice || !provider) return null;

  const copy = l10n.rematching.outOfOffice;
  const startDate = CalendarDateService.date(outOfOffice.startDate).format('MMMM D');
  const endDate = CalendarDateService.date(outOfOffice.endDate).format('MMMM D, YYYY');

  return (
    <Alert severity="warning" title={copy.title(provider.nameDisplay.defaultDisplay)} sx={{ mt: 3 }}>
      <Typography variant="body2">
        {copy.dates(startDate, endDate)}
      </Typography>
      <Typography variant="body2" mt={1}>
        {copy.noRematchNeeded}{' '}
        <Link href={`mailto:${l10n.helpEmail}`}>
          {l10n.helpEmail}
        </Link>
        .
      </Typography>
    </Alert>
  );
};
